export enum ToastType {
  AMOUNT_INFO_TOAST = 'amount info toast',
  FEATURE_PROMOTIONS_TOAST = 'feature promotions toast',
  COUPON_PROGRESS_TOAST = 'coupon progress toast',
  MARKETING_ORDER_PROMO_TOAST = 'marketing order promo toast',
  PREFERRED_SHOPPER_PAIRING_TOAST = 'preferred shopper pairing toast',
  IMAGE_TOAST = 'image toast',
  TEXT_TOAST = 'text toast',
  ICON_TOAST = 'icon toast',
  NO_MARKUPS_TOAST = 'no markups toast',
  FREE_ITEM_ADDED_TOAST = 'free item added toast',
}
